import {FormControl, FormGroup} from '@angular/forms';

import {BaseControl, CheckboxControl} from 'appShared/classes/controls';
import {
    HttpStatusCodesEnum,
    MarketDataFeedBundleInputModel,
    MarketDataFeedBundleInterface,
    MarketDataFeedBundleModel,
    ServerResponse,
    ServerResponseData,
    SesHelper,
    SesService
} from '@spa/api';
import {ColorCodesEnum, ComponentTypesEnum} from 'appShared/enums';
import {map} from 'rxjs/operators';
import {Helper} from 'appShared/classes';
import {MarketDataFeedBundleFormErrorStatesEnum, MarketDataFeedsFormErrorStatesEnum} from 'appEntries/panel/enums';
import {BaseMarketDataForm} from 'appShared/forms';
import {MarketDataFeedAndBundleDeleteInterface} from 'appEntries/panel/interfaces';
import {MarketDataFeedsAddMessages} from 'appAssets/messages';
import {FEEDID_CHECKBOX_PREFIX} from 'appAssets/descriptors';

export class RemoveFeedBundleForm extends BaseMarketDataForm {
    private readonly feeds: MarketDataFeedAndBundleDeleteInterface[];
    private readonly bundle: MarketDataFeedBundleModel;

    constructor(sesService: SesService, feeds: MarketDataFeedAndBundleDeleteInterface[], bundle: MarketDataFeedBundleModel) {
        super(sesService);
        this.feeds = feeds;
        this.bundle = bundle;
    }

    initForm(): void {
        this.formGroup = new FormGroup({});
        const feedControls = [];

        for (const feed of this.feeds) {
            feedControls.push(
                new CheckboxControl({
                    name: `${FEEDID_CHECKBOX_PREFIX}${feed.id}`,
                    value: feed.id,
                    placeholder: feed.name,
                    validators: [],
                    componentType: ComponentTypesEnum.Checkbox,
                    floatingLabelNever: true,
                    checked: false,
                    color: ColorCodesEnum.Primary,
                    expectBooleanValue: false
                })
            );
        }

        this.controls = feedControls.map((control: BaseControl) => {
            this.formGroup.addControl(control.name, new FormControl(control.value, control.validators));

            return control;
        });
    }

    createRequest(): ServerResponse<boolean> {
        const selectedIds: number[] = [];

        // tslint:disable-next-line:forin
        for (const property in this.formGroup.value) {
            const feedId = this.formGroup.value[property];
            if (feedId > 0) {
                selectedIds.push(feedId);
            }
        }

        if (selectedIds.length === 0) {
            return Helper.errorsHelper().createBadRequestResponseObservable(
                MarketDataFeedBundleFormErrorStatesEnum.MarketDataFeedOfBundleRemoveFailedNeedToSelectMinFeed
            );
        }

        const unselectedList: number[] = [];

        this.bundle.feedList.forEach(feed => {
            if (!selectedIds.includes(feed.id)) {
                unselectedList.push(feed.id);
            }
        });

        if (!this.bundle.platformFrontend && unselectedList.length === 0) {
            return Helper.errorsHelper().createBadRequestMessageResponseObservable(
                MarketDataFeedsAddMessages.MarketDataFeedOfBundleRemoveFailedNeedToStayMinFeedOrPFE.message
            );
        }

        const model = new MarketDataFeedBundleInputModel(
            this.bundle.name,
            this.bundle.description,
            SesHelper.getPriceCurrency(this.bundle.priceList),
            this.bundle.priceList[0]?.defaultNonProPrice,
            this.bundle.priceList[0]?.defaultNonProPrice,
            this.bundle.priceList[0]?.alaricInternalPrice,
            this.bundle.priceList[0]?.alaricNonProPrice,
            this.bundle.priceList[0]?.alaricProPrice,
            unselectedList,
            this.bundle.platformFrontend?.id
        );

        return this.sesService.updateMarketDataFeedBundle(this.bundle.id, model).pipe(
            map((response: ServerResponseData<MarketDataFeedBundleInterface>) => {

                if (response && response.status !== HttpStatusCodesEnum.Ok) {
                    return Helper.errorsHelper().createErrorResponse<MarketDataFeedBundleInterface>(
                        response,
                        MarketDataFeedsFormErrorStatesEnum.DeleteMarketDataFeedFailed
                    );
                }

                return Helper.createSuccessResponse<boolean>(true);
            }));
    }
}
